var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/money"
  }, /*#__PURE__*/React.createElement("g", {
    id: "money"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 4.23926H7C4 4.23926 2 5.73926 2 9.23926V16.2393C2 19.7393 4 21.2393 7 21.2393H17C20 21.2393 22 19.7393 22 16.2393V9.23926C22 5.73926 20 4.23926 17 4.23926ZM6.25 15.2393C6.25 15.6493 5.91 15.9893 5.5 15.9893C5.09 15.9893 4.75 15.6493 4.75 15.2393V10.2393C4.75 9.82926 5.09 9.48926 5.5 9.48926C5.91 9.48926 6.25 9.82926 6.25 10.2393V15.2393ZM12 15.7393C10.34 15.7393 9 14.3993 9 12.7393C9 11.0793 10.34 9.73926 12 9.73926C13.66 9.73926 15 11.0793 15 12.7393C15 14.3993 13.66 15.7393 12 15.7393ZM19.25 15.2393C19.25 15.6493 18.91 15.9893 18.5 15.9893C18.09 15.9893 17.75 15.6493 17.75 15.2393V10.2393C17.75 9.82926 18.09 9.48926 18.5 9.48926C18.91 9.48926 19.25 9.82926 19.25 10.2393V15.2393Z",
    fill: "#294DD8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.13c07fce1c74a13db50a6fed52ccce56.svg";
export { ForwardRef as ReactComponent };